import { API_DOCUMENT_DOWNLOAD, API_DOCUMENT_UPLOAD } from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const downloadFileAPI = ({ fileAddress }) => {
  let postData = {
    file: fileAddress,
  };
  return axiosMiddleware({
    method: "post",
    url: API_DOCUMENT_DOWNLOAD,
    data: postData,
  });
};
export const uploadFileAPI = (formData, uploadPercent) => {
  let postData = formData;
  return axiosMiddleware({
    method: "post",
    url: API_DOCUMENT_UPLOAD,
    timeout: 60000,
    data: postData,
    trackUploadProgress: (percent) => {
      uploadPercent(percent);
    },
  });
};
